export default "/images/vendor/flag-icon-css/flags/4x3/ch.svg?a362d2b8e05b0981ba7907893dee9c48";